var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["widget-step amount-step", { active: _vm.isActiveStep }],
      attrs: { "data-test-id": "fill-amount" }
    },
    [
      _c(
        "StepTitle",
        {
          attrs: { stepNumber: _vm.stepNumber },
          nativeOn: {
            click: function($event) {
              return _vm.$emit("setStep", _vm.stepNumber)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "widget-step__title",
              attrs: { "data-test-id": "fill-amount-title" }
            },
            [
              _c(
                "div",
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.i18n.amount_step_title()) +
                      "\n        "
                  ),
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.selectedAsset && _vm.showTooltip,
                          expression: "selectedAsset && showTooltip"
                        }
                      ],
                      staticClass:
                        "md-icon-button md-raised widget-step__tooltip-button",
                      attrs: { "data-test-id": "fill-amount-tooltip-btn" }
                    },
                    [
                      _c("md-icon", {
                        attrs: {
                          "md-src": "/static/img/info-icon.svg",
                          "data-test-id": "fill-amount-tooltip-btn-icon"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "md-tooltip",
                        {
                          staticClass: "min-withdrawal-tooltip",
                          attrs: {
                            "md-direction": "bottom",
                            "data-test-id": "min-withdrawal-tooltip"
                          }
                        },
                        [
                          _vm.hasMinAmount
                            ? _c(
                                "p",
                                {
                                  attrs: {
                                    "data-test-id":
                                      "min-withdrawal-tooltip-min-msg"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.commissionDescription) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.limitList, function(item, key) {
                            return _c(
                              "div",
                              { key: key },
                              [
                                item.period === "operation" ||
                                item.period === "day"
                                  ? [
                                      item.period === "operation"
                                        ? _c(
                                            "p",
                                            {
                                              attrs: {
                                                "data-test-id":
                                                  "min-withdrawal-tooltip-operation-msg"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.i18n.lim_withdrawal_daily_msg1(
                                                      {
                                                        limit:
                                                          item.amount_limit,
                                                        asset: _vm.selectedAsset
                                                      }
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.period === "day"
                                        ? _c(
                                            "p",
                                            {
                                              attrs: {
                                                "data-test-id":
                                                  "min-withdrawal-tooltip-day-msg"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.i18n.lim_withdrawal_daily_msg2(
                                                      {
                                                        limit:
                                                          item.amount_limit,
                                                        asset: _vm.selectedAsset
                                                      }
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "border-none",
                              attrs: {
                                "data-test-id":
                                  "min-withdrawal-tooltip-holiday-msg"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.i18n.lim_withdrawal_daily_msg3()) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.amount &&
                        !_vm.amount.includes("NaN") &&
                        !_vm.isActiveStep,
                      expression:
                        "amount && !amount.includes('NaN') && !isActiveStep"
                    }
                  ],
                  attrs: { "data-test-id": "selected-amount" }
                },
                [_vm._v("\n        " + _vm._s(_vm.amount) + "\n      ")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.isActiveStep
        ? _c("AccordeonWrapper", [
            _c(
              "div",
              {
                staticClass: "widget-step__inner",
                attrs: { "data-test-id": "fill-amount-container" }
              },
              [
                _c("input-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|amount",
                      expression: "'required|amount'"
                    }
                  ],
                  staticClass: "field__number",
                  attrs: {
                    "data-test-id": "fill-amount-input",
                    label: "",
                    name: "amount",
                    type: "number",
                    title: "Amount",
                    align: "right",
                    vvValidateOn: "change",
                    errorMessage: _vm.amountFieldErrors,
                    autofocus: true
                  },
                  on: { blur: _vm.onBlurHandler },
                  model: {
                    value: _vm.amount,
                    callback: function($$v) {
                      _vm.amount = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "amount"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "validation-error",
                    attrs: { "data-test-id": "fill-amount-input-error" }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.amountFieldErrors ? _vm.amountFieldErrors : ""
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      "fees-container",
                      { loading: _vm.isFeesLoadPending }
                    ]
                  },
                  [
                    _vm.amount && _vm.amount > 0 && !_vm.amountFieldErrors
                      ? _c(
                          "div",
                          { attrs: { "data-test-id": "fill-amount-fees" } },
                          [
                            _c(
                              "p",
                              {
                                attrs: {
                                  "data-test-id": "fill-amount-fixed-fee"
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.feesFixedMsg) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isFeesCharged
                              ? _c(
                                  "p",
                                  {
                                    attrs: {
                                      "data-test-id": "fill-amount-charged"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.willChargedMsg) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c06dd4d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c06dd4d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/WithdrawalWidget/FillAmount.vue
// module id = 4cvr
// module chunks = 1